/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    GenerateTwoFactorQrCode200,
    GetMe200,
    LoginBody,
    LoginSuccessResponseResponse,
    ResetDefaultPassword200,
    ResetDefaultPasswordBody,
    ResetPasswordBody,
    ResetPasswordRequest200,
    ResetPasswordRequestBody,
    ResetTwoFactor200,
    ResetTwoFactorBody,
    UserEmailSuccessResponseResponse,
    VerifyTwoFactor200,
    VerifyTwoFactorBody,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Log in to the application
 */
export const login = (loginBody: LoginBody, signal?: AbortSignal) => {
    return customInstance<LoginSuccessResponseResponse>({
        url: `/auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginBody,
        signal,
    });
};

export const getLoginMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof login>>,
        TError,
        { data: LoginBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: LoginBody },
    TContext
> => {
    const mutationKey = ['login'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, { data: LoginBody }> = (
        props,
    ) => {
        const { data } = props ?? {};

        return login(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>;
export type LoginMutationBody = LoginBody;
export type LoginMutationError = APIErrorResponseResponse;

/**
 * @summary Log in to the application
 */
export const useLogin = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof login>>,
        TError,
        { data: LoginBody },
        TContext
    >;
}): UseMutationResult<Awaited<ReturnType<typeof login>>, TError, { data: LoginBody }, TContext> => {
    const mutationOptions = getLoginMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Switch venue in to the application
 */
export const switchVenue = (venueId: number, signal?: AbortSignal) => {
    return customInstance<LoginSuccessResponseResponse>({
        url: `/auth/switchvenue/${venueId}`,
        method: 'POST',
        signal,
    });
};

export const getSwitchVenueMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof switchVenue>>,
        TError,
        { venueId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof switchVenue>>,
    TError,
    { venueId: number },
    TContext
> => {
    const mutationKey = ['switchVenue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof switchVenue>>,
        { venueId: number }
    > = (props) => {
        const { venueId } = props ?? {};

        return switchVenue(venueId);
    };

    return { mutationFn, ...mutationOptions };
};

export type SwitchVenueMutationResult = NonNullable<Awaited<ReturnType<typeof switchVenue>>>;

export type SwitchVenueMutationError = APIErrorResponseResponse;

/**
 * @summary Switch venue in to the application
 */
export const useSwitchVenue = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof switchVenue>>,
        TError,
        { venueId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof switchVenue>>,
    TError,
    { venueId: number },
    TContext
> => {
    const mutationOptions = getSwitchVenueMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Reset user password
 */
export const resetPassword = (resetPasswordBody: ResetPasswordBody, signal?: AbortSignal) => {
    return customInstance<UserEmailSuccessResponseResponse>({
        url: `/reset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resetPasswordBody,
        signal,
    });
};

export const getResetPasswordMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        { data: ResetPasswordBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: ResetPasswordBody },
    TContext
> => {
    const mutationKey = ['resetPassword'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof resetPassword>>,
        { data: ResetPasswordBody }
    > = (props) => {
        const { data } = props ?? {};

        return resetPassword(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>;
export type ResetPasswordMutationBody = ResetPasswordBody;
export type ResetPasswordMutationError = APIErrorResponseResponse;

/**
 * @summary Reset user password
 */
export const useResetPassword = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        { data: ResetPasswordBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: ResetPasswordBody },
    TContext
> => {
    const mutationOptions = getResetPasswordMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary User password reset request
 */
export const resetPasswordRequest = (
    resetPasswordRequestBody: ResetPasswordRequestBody,
    signal?: AbortSignal,
) => {
    return customInstance<ResetPasswordRequest200>({
        url: `/resetRequest`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resetPasswordRequestBody,
        signal,
    });
};

export const getResetPasswordRequestMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetPasswordRequest>>,
        TError,
        { data: ResetPasswordRequestBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof resetPasswordRequest>>,
    TError,
    { data: ResetPasswordRequestBody },
    TContext
> => {
    const mutationKey = ['resetPasswordRequest'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof resetPasswordRequest>>,
        { data: ResetPasswordRequestBody }
    > = (props) => {
        const { data } = props ?? {};

        return resetPasswordRequest(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ResetPasswordRequestMutationResult = NonNullable<
    Awaited<ReturnType<typeof resetPasswordRequest>>
>;
export type ResetPasswordRequestMutationBody = ResetPasswordRequestBody;
export type ResetPasswordRequestMutationError = APIErrorResponseResponse;

/**
 * @summary User password reset request
 */
export const useResetPasswordRequest = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetPasswordRequest>>,
        TError,
        { data: ResetPasswordRequestBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof resetPasswordRequest>>,
    TError,
    { data: ResetPasswordRequestBody },
    TContext
> => {
    const mutationOptions = getResetPasswordRequestMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary User password reset request during create user
 */
export const resetDefaultPassword = (
    resetDefaultPasswordBody: ResetDefaultPasswordBody,
    signal?: AbortSignal,
) => {
    return customInstance<ResetDefaultPassword200>({
        url: `/resetDefault`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resetDefaultPasswordBody,
        signal,
    });
};

export const getResetDefaultPasswordMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetDefaultPassword>>,
        TError,
        { data: ResetDefaultPasswordBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof resetDefaultPassword>>,
    TError,
    { data: ResetDefaultPasswordBody },
    TContext
> => {
    const mutationKey = ['resetDefaultPassword'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof resetDefaultPassword>>,
        { data: ResetDefaultPasswordBody }
    > = (props) => {
        const { data } = props ?? {};

        return resetDefaultPassword(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ResetDefaultPasswordMutationResult = NonNullable<
    Awaited<ReturnType<typeof resetDefaultPassword>>
>;
export type ResetDefaultPasswordMutationBody = ResetDefaultPasswordBody;
export type ResetDefaultPasswordMutationError = APIErrorResponseResponse;

/**
 * @summary User password reset request during create user
 */
export const useResetDefaultPassword = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetDefaultPassword>>,
        TError,
        { data: ResetDefaultPasswordBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof resetDefaultPassword>>,
    TError,
    { data: ResetDefaultPasswordBody },
    TContext
> => {
    const mutationOptions = getResetDefaultPasswordMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Reset user's two factor authentication
 */
export const resetTwoFactor = (resetTwoFactorBody: ResetTwoFactorBody, signal?: AbortSignal) => {
    return customInstance<ResetTwoFactor200>({
        url: `/auth/2fa/reset`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: resetTwoFactorBody,
        signal,
    });
};

export const getResetTwoFactorMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetTwoFactor>>,
        TError,
        { data: ResetTwoFactorBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof resetTwoFactor>>,
    TError,
    { data: ResetTwoFactorBody },
    TContext
> => {
    const mutationKey = ['resetTwoFactor'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof resetTwoFactor>>,
        { data: ResetTwoFactorBody }
    > = (props) => {
        const { data } = props ?? {};

        return resetTwoFactor(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ResetTwoFactorMutationResult = NonNullable<Awaited<ReturnType<typeof resetTwoFactor>>>;
export type ResetTwoFactorMutationBody = ResetTwoFactorBody;
export type ResetTwoFactorMutationError = APIErrorResponseResponse;

/**
 * @summary Reset user's two factor authentication
 */
export const useResetTwoFactor = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof resetTwoFactor>>,
        TError,
        { data: ResetTwoFactorBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof resetTwoFactor>>,
    TError,
    { data: ResetTwoFactorBody },
    TContext
> => {
    const mutationOptions = getResetTwoFactorMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Generate a new 2FA QR code URI and secret
 */
export const generateTwoFactorQrCode = (signal?: AbortSignal) => {
    return customInstance<GenerateTwoFactorQrCode200>({
        url: `/auth/2fa/generate-qr`,
        method: 'POST',
        signal,
    });
};

export const getGenerateTwoFactorQrCodeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof generateTwoFactorQrCode>>,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof generateTwoFactorQrCode>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ['generateTwoFactorQrCode'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof generateTwoFactorQrCode>>,
        void
    > = () => {
        return generateTwoFactorQrCode();
    };

    return { mutationFn, ...mutationOptions };
};

export type GenerateTwoFactorQrCodeMutationResult = NonNullable<
    Awaited<ReturnType<typeof generateTwoFactorQrCode>>
>;

export type GenerateTwoFactorQrCodeMutationError = APIErrorResponseResponse;

/**
 * @summary Generate a new 2FA QR code URI and secret
 */
export const useGenerateTwoFactorQrCode = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof generateTwoFactorQrCode>>,
        TError,
        void,
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof generateTwoFactorQrCode>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions = getGenerateTwoFactorQrCodeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Verify a 2FA code and enable 2FA if successful
 */
export const verifyTwoFactor = (verifyTwoFactorBody: VerifyTwoFactorBody, signal?: AbortSignal) => {
    return customInstance<VerifyTwoFactor200>({
        url: `/auth/2fa/verify`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: verifyTwoFactorBody,
        signal,
    });
};

export const getVerifyTwoFactorMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof verifyTwoFactor>>,
        TError,
        { data: VerifyTwoFactorBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof verifyTwoFactor>>,
    TError,
    { data: VerifyTwoFactorBody },
    TContext
> => {
    const mutationKey = ['verifyTwoFactor'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof verifyTwoFactor>>,
        { data: VerifyTwoFactorBody }
    > = (props) => {
        const { data } = props ?? {};

        return verifyTwoFactor(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type VerifyTwoFactorMutationResult = NonNullable<
    Awaited<ReturnType<typeof verifyTwoFactor>>
>;
export type VerifyTwoFactorMutationBody = VerifyTwoFactorBody;
export type VerifyTwoFactorMutationError = APIErrorResponseResponse;

/**
 * @summary Verify a 2FA code and enable 2FA if successful
 */
export const useVerifyTwoFactor = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof verifyTwoFactor>>,
        TError,
        { data: VerifyTwoFactorBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof verifyTwoFactor>>,
    TError,
    { data: VerifyTwoFactorBody },
    TContext
> => {
    const mutationOptions = getVerifyTwoFactorMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get the current user
 */
export const getMe = (signal?: AbortSignal) => {
    return customInstance<GetMe200>({ url: `/me`, method: 'GET', signal });
};

export const getGetMeQueryKey = () => {
    return [`/me`] as const;
};

export const getGetMeQueryOptions = <
    TData = Awaited<ReturnType<typeof getMe>>,
    TError = APIErrorResponseResponse,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getMe>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = APIErrorResponseResponse;

/**
 * @summary Get the current user
 */

export function useGetMe<
    TData = Awaited<ReturnType<typeof getMe>>,
    TError = APIErrorResponseResponse,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetMeQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
